module.exports = __webpack_public_path__ + "img/2018-10-19.0af17635.jpg";